import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { GoogleEventsService } from 'src/app/shared/analyticservice/google-events.service';

@Component({
  selector: 'app-new-order-modal',
  templateUrl: './new-order-modal.component.html',
  styleUrls: [
    './new-order-modal.component.scss',
    './new-order-modal.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class NewOrderModalComponent implements OnInit {
  @Output() cancelOrderModal = new EventEmitter();
  @Output() newOrderModal = new EventEmitter();
  constructor(private analyticService: GoogleEventsService) {}

  ngOnInit(): void {
    //For futureUse
  }

  onClickRepeat() {
    this.newOrderModal.emit('repeat');
    this.RepeatOrderButtonClicked();
  }

  onClickNew() {
    this.newOrderModal.emit('new');
    this.newOrderClickEvent();
  }

  onClickCloseModal() {
    window.location.reload();
    this.cancelOrderModal.emit(null);
    this.CloseOrderFromSuccesful();
  }
  // <---------------- Google-Analytics Strats -------------->
  newOrderClickEvent() {
    let action = 'NewOrderClicked';
    let category = 'Core Purchasing Activity';
    let label = 'Click New Order from OrderSuccesfull';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  RepeatOrderButtonClicked() {
    let action = 'RepeatOrderButtonClicked';
    let category = 'Core Purchasing Activity';
    let label = 'Click RepeatOrderFromOrderSuccessful';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  CloseOrderFromSuccesful() {
    let action = 'CloseOrderFromSuccesful';
    let category = 'Core Purchasing Activity';
    let label = 'Click CloseOrderFromOrderConfSuccess';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  // <---------------- Google-Analytics Ends -------------->
}
